// Home page at `/`. Ported from the design bundle's HomeScreen.jsx —
// dense Bulgarian body copy, inline navy legal links, red alert words.
// Wrapped in a shadcn Card for the main content + right-rail sidebar.

import { Card, CardContent, H1, P } from '@podium/platform/ui'
import { createFileRoute } from '@tanstack/react-router'

import { AlertWord, EDocsSidebar, PaymentsPromo } from '../components/brand'

export const Route = createFileRoute('/')({
  component: IndexPage,
})

function IndexPage() {
  return (
    <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 px-6 py-8 lg:grid-cols-[1fr_260px]">
      <Card>
        <CardContent className="space-y-4 pt-6 leading-relaxed">
          <H1>Публикуване на годишен финансов отчет</H1>

          <P className="font-semibold">
            Предоставяме Ви възможност бързо, лесно и много евтино{' '}
            <a href="/publish">да публикувате финансов отчет</a> в съответствие с изискванията на{' '}
            <a href="/law#csch-38-1-3">чл. 38, ал.1, т.3</a> от ЗСч.
          </P>

          <P>
            <AlertWord>САМО ЗА</AlertWord> <s>10 лв. / 5.11 €</s>{' '}
            <AlertWord>7 лв. / 3.58 €</AlertWord> — просто сканирайте Вашия отчет и го прикачете във{' '}
            <a href="/publish">формата за публикуване</a>.
          </P>

          <P>
            или ни го изпратете на E-mail{' '}
            <a href="mailto:office@godishni-otcheti.com">office@godishni-otcheti.com</a> (на цена 10
            лв. / 5.11 €) заедно със съпътстващата информация — наименование, адрес, ЕИК/БУЛСТАТ,
            представляващ / МОЛ на предприятието или организацията, чийто отчет публикувате.
          </P>

          <P>
            След това, <a href="/prices">платете таксата по един от предоставените начини</a> и до
            24 часа отчетът Ви ще бъде публикуван. Ще получите по E-mail линк към публикацията в
            съответствие с изискванията на <a href="/law#csch-38-8">чл. 38, ал. 8</a>. Ще получите и
            фактура за извършеното плащане.
          </P>

          <P>
            Таксата е за целия тригодишен период, в който до отчетите трябва да бъде осигурен
            свободен неплатен достъп.
          </P>

          <P>
            <AlertWord>ЗАДЪЛЖИТЕЛНО</AlertWord> трябва да публикуват годишен финансов отчет в
            интернет или икономическо издание следните субекти:
          </P>

          <ul className="list-disc space-y-2 pl-6">
            <li>
              Всички дружества по <a href="/law#zzd">Закона за задълженията и договорите</a> (ДЗЗД)
              — неперсонифицирани дружества или граждански дружества по ЗЗД.
            </li>
            <li>
              Юридическите лица, които не са търговци (ЮЛ с нестопанска цел) и{' '}
              <AlertWord>НЕ СА</AlertWord> вписани в Централния регистър на юридическите лица в
              обществена полза към Министерство на правосъдието.
            </li>
            <li>
              Чуждестранни лица, осъществяващи стопанска дейност на територията на страната чрез
              място на стопанска дейност и търговски представителства.
            </li>
            <li>
              Предприятията, подлежащи на независим финансов одит, които не са регистрирани /
              пререгистрирани в Търговския регистър.
            </li>
          </ul>

          <PaymentsPromo />
        </CardContent>
      </Card>

      <EDocsSidebar />
    </div>
  )
}
